<div class="result-failed-container">
  <i class="bi bi-bug"></i>
  <p>เกิดข้อผิดพลาดบางอย่าง</p>
</div>
